<template>
  <div
    class="d-flex flex-column justify-content-center h-100 m-auto my-4 p-4"
    style="gap: 5px"
  >
    <div class="semibold">Non è possibile scegliere i posti</div>
    <div>
      La compagnia non permette la selezione in questa fase e
      assegnerà automaticamente i posti. La compagnia non
      garantisce che i passeggeri adulti viaggino vicini.
    </div>
    <div>
      Normalmente, a seconda delle regole della compagnia,
      potrai scegliere i posti durante il check-in online o in
      aeroporto.
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeckDisabledMessage',
}
</script>
